// extracted by mini-css-extract-plugin
export var infoSection = "_e-1";
export var infoSectionContainer = "_e-0";
export var infoSectionTitleRow = "_e-2";
export var multiLineInfo = "_e-4";
export var strong = "_e-3";